import { sendRequestNoAuth } from 'transport/sendRequestNoAuth'
import { sendRequestWithAuth } from 'transport/sendRequestWithAuth'
import { isLkmDomain } from 'router/utils'

import {
  GetSmsParams,
  GetSmsResponseData,
  LoginParams,
  LoginResponseData,
  LogoutResponseData,
  RefreshTokenResponseData,
} from '../types'

import { authApiUrl, lkmAuthApiUrl } from './authApiUrls'

const currentAuthApiUrl = isLkmDomain() ? lkmAuthApiUrl : authApiUrl

export const getSms = (param: GetSmsParams) =>
  sendRequestNoAuth.post<GetSmsResponseData>(currentAuthApiUrl.sms, param)

export const login = (param: LoginParams) =>
  sendRequestNoAuth.post<LoginResponseData>(currentAuthApiUrl.login, param)

export const logout = () =>
  sendRequestWithAuth.post<LogoutResponseData>(currentAuthApiUrl.logout)

// eslint-disable-next-line max-len
export const refreshToken = (token: string) =>
  sendRequestNoAuth.post<RefreshTokenResponseData>(
    currentAuthApiUrl.refresh,
    {},
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  )
